import {mapMutations, mapGetters} from 'vuex';
import {
    SHOW_POPUP_AVAILABILITY_PROPS,
    SHOW_POPUP_BASKET,
    SHOW_POPUP_EDIT_TO_BASKET,
    SHOW_POPUP_TEXT_CONTENT,
    CHANGE_POPUP_RESTORE_PASSWORD,
    CHANGE_POPUP_NEW_PASSWORD,
    SHOW_POPUP_REMOVE_FROM_BASKET,
    SHOW_POPUP_UPDATE_PASSWORD,
    CHANGE_POPUP_EDIT_DATE,
    FAVORITES_REPORT_APPERANCE_SHOW_POPUP,
    FAVORITES_SHOW_POPUP_EDIT_NAME_LIST,
    FAVORITES_CHANGE_POPUP_ADD_PERMISSIONS,
    CHANGE_POPUP_ADD_TO_FAVORITES,
    CHANGE_POPUP_BOOKING,
    SHOW_POPUP_REMOVE_FROM_FAVORITES,
    CHANGE_POPUP_LDAP,
    POPUP_ORDER,
    CHANGE_POPUP_FAVORITES_REMOVE_LIST,
    SHOW_POPUP_AUTH_LDAP_WARNING
} from "@/store/mutation-types";

//
const requisiteCheck = () => import('@/components/popups/requisite-check/index.vue');
const requisiteAddBasket = () => import('@/components/popups/add-basket/index.vue');
const requisiteAddFavorites = () => import('@/components/popups/add-favorites/index.vue');
const editBasket = () => import('@/components/popups/edit-basket/index.vue');
const thanks = () => import('@/components/popups/thanks/index.vue');
const restorePasswordEmail = () => import('@/components/popups/restore-password-email/index.vue');
const setNewPassword = () => import('@/components/popups/set-new-password/index.vue');
const booking = () => import('@/components/popups/booking/index.vue');
const updatePassword = () => import('@/components/popups/change-password/index.vue');
const removeItemFromBasket = () => import('@/components/popups/remove-item-from-basket/index.vue');
const removeItemFromFavorites = () => import('@/components/popups/remove-item-from-favorites/index.vue');
const removeListFromFavorites = () => import('@/components/popups/remove-list-from-favorites/index.vue');
const editDateFavoritesItem = () => import('@/modules/profile/pages/favorites/components/popup-edit-date/index.vue');
const editNameFavoritesList = () => import('@/modules/profile/pages/favorites/components/popup-edit-name/index.vue');
const reportApperancePopup = () => import('@/modules/profile/pages/favorites/components/popup-report-apperance/index.vue');
const addPermissions = () => import('@/modules/profile/pages/favorites/components/popup-add-permissions/index.vue');
const authLdap = () => import('@/components/popups/auth-ldap/index.vue');
const cancelOrder = () => import('@/components/popups/cancel-order/index.vue');
const ldapWarning = () => import('@/components/popups/auth-ldap-warning/index.vue');
export default {
    name: 'hidden',
    components: {
        thanks,
        editBasket,
        requisiteCheck,
        restorePasswordEmail,
        removeItemFromBasket,
        removeListFromFavorites,
        requisiteAddBasket,
        updatePassword,
        editDateFavoritesItem,
        setNewPassword,
        editNameFavoritesList,
        reportApperancePopup,
        addPermissions,
        requisiteAddFavorites,
        booking,
        authLdap,
        cancelOrder,
        ldapWarning,
        removeItemFromFavorites
    },
    computed: {
        ...mapGetters({
            showPopupCheckAvailability: 'requisite/showPopupCheckAvailability',
            showPopupBasket: 'requisite/showPopupBasket',
            showPopupEdit: 'basket/showPopupEdit',
            showPopupRemoveItem: 'basket/showPopupRemoveItem',
            showPopupRemoveItemFavorites: 'favorites/showPopupRemoveItem',
            popupRemoveList: 'favorites/popupRemoveList',
            popup: 'system/popup',
            popupTextShow: 'system/popupTextShow',
            showRestorePassword: 'auth/showRestorePassword',
            showSetNewPassword: 'auth/showSetNewPassword',
            showPopupUpdatePassword: 'profile/showPopupUpdatePassword',
            showPopupEditDate: 'favorites/showPopupEditDate',
            showPopupEditNameList: 'favorites/showPopupEditNameList',
            reportApperanceShowPopup: 'favorites/reportApperanceShowPopup',
            showPopupAddPermissions: 'favorites/showPopupAddPermissions',
            showPopupAddFavorites: 'favorites/showPopupAddFavorites',
            showPopupBooking: 'favorites/showPopupBooking',
            showPopupLdap: 'auth/showPopupLdap',
            popupOrder: 'orders/popupOrder',
            showPopupLdapWarning: 'auth/popupLdapWarning',
        })
    },
    methods: {
        ...mapMutations({
            changePopupCheck: `requisite/${SHOW_POPUP_AVAILABILITY_PROPS}`,
            changePopupBasket: `requisite/${SHOW_POPUP_BASKET}`,
            changePopupEditBasket: `basket/${SHOW_POPUP_EDIT_TO_BASKET}`,
            changeShowPopupText: `system/${SHOW_POPUP_TEXT_CONTENT}`,
            changeShowRemovePopup: `basket/${SHOW_POPUP_REMOVE_FROM_BASKET}`,
            changeShowRemovePopupFavorites: `favorites/${SHOW_POPUP_REMOVE_FROM_FAVORITES}`,
            changePopupRemoveListFromFavorites: `favorites/${CHANGE_POPUP_FAVORITES_REMOVE_LIST}`,
            changePopupRestorePasswordEmail: `auth/${CHANGE_POPUP_RESTORE_PASSWORD}`,
            changePopupNewPassword: `auth/${CHANGE_POPUP_NEW_PASSWORD}`,
            changePopupUpdatePassword: `profile/${SHOW_POPUP_UPDATE_PASSWORD}`,
            changePopupEditDateInFavorites: `favorites/${CHANGE_POPUP_EDIT_DATE}`,
            changeShowPopupRenameList: `favorites/${FAVORITES_SHOW_POPUP_EDIT_NAME_LIST}`,
            changeShowPopupReportApperance: `favorites/${FAVORITES_REPORT_APPERANCE_SHOW_POPUP}`,
            changePopupAddPermissions: `favorites/${FAVORITES_CHANGE_POPUP_ADD_PERMISSIONS}`,
            changePopupAddFavorites: `favorites/${CHANGE_POPUP_ADD_TO_FAVORITES}`,
            changePopupBooking: `favorites/${CHANGE_POPUP_BOOKING}`,
            changePopupLdap: `auth/${CHANGE_POPUP_LDAP}`,
            cancelOrder: `orders/${POPUP_ORDER}`,
            changePopupLdapWarning: `auth/${SHOW_POPUP_AUTH_LDAP_WARNING}`,
        })
    }
}
